import { Expose } from "class-transformer";
import { IsString, IsNumber } from "class-validator";

export class OfficeDocumentType {
  @IsNumber()
  @Expose()
  id!: number;
  @IsString()
  @Expose()
  name!: string;
}
